import { APP_ENV, ENVIRONMENT } from 'env/environment'

export const TITLE_LABEL = 'Add Contribution Points'
export const PROPERTY_LABEL = 'Property'
export const FIELDS_AMOUNT_LABEL = 'Number of Subdomains to add'

const ADORNMENTS = {
  [ENVIRONMENT.PRODUCTION]: '.vid-in.imgarena.com',
  [ENVIRONMENT.STAGING]: '.vid-in-staging.imgarena.dev',
  [ENVIRONMENT.DEVELOPMENT]: '.vid-in-dev.imgarena.dev',
  [ENVIRONMENT.DDE_SIMULATION]: '.vid-in-dev.imgarena.dev',
  [ENVIRONMENT.TEST]: '.vid-in-dev.imgarena.dev'
} as const

// srarena builds override the vid-in subdomain via VITE_VID_IN_ADORNMENT; imgarena builds fall back to the map.
export const ADORNMENT = import.meta.env.VITE_VID_IN_ADORNMENT || ADORNMENTS[APP_ENV]

export const makeSubdomainFieldLabel = (index: number) => `Subdomain ${index + 1}` as const
